import { SURFACE_INITIAL, SURFACE_INTERACTION } from '../surface/contract.js';

const INITIAL_VALUES = new Set(Object.values(SURFACE_INITIAL));
const INTERACTION_VALUES = new Set(Object.values(SURFACE_INTERACTION));

/** Runtime surface contract selected by the Exchange. */
export class SurfaceRequirements {
  constructor(raw) {
    if (!raw || !INITIAL_VALUES.has(raw.initial))
      throw new Error('TagBid.surface.initial is invalid');
    if (!INTERACTION_VALUES.has(raw.interaction))
      throw new Error('TagBid.surface.interaction is invalid');
    this._initial = raw.initial;
    this._interaction = raw.interaction;
  }

  get initial() { return this._initial; }
  get interaction() { return this._interaction; }

  get requiresDirectRender() {
    return this._initial !== SURFACE_INITIAL.Allocated
      || this._interaction !== SURFACE_INTERACTION.Fixed;
  }
}
